<template>
  <div>
    <div class="detail">
      <div
        class="action"
        ref="action"
      >
        <el-button
          type="primary"
          @click="refreshData"
          class="top-button"
        >刷新数据</el-button>
        <!--汇总点击详情无以下操作-->
        <div
          v-if="!accu"
          style="display:flex;"
        >
          <el-button
            type="primary"
            @click="exportExcel"
            class="top-button"
          >导出数据</el-button>
          <div v-if="projectInfo['status:project_status']!=='待启动'">
            <el-button
              type="primary"
              @click="changeEstimatedTimeDrawer = true"
              class="top-button"
              v-if="available.indexOf(currUser.username) !== -1"
            >
              修改预计交付时间
            </el-button>
          </div>
          <div v-if="projectInfo['status:project_status']=='待启动'">
            <el-button
              type="primary"
              @click="prepareStartProgressDrawer = true"
              class="top-button"
              v-if="available.indexOf(currUser.username) !== -1"
            >
              启动项目
            </el-button>
          </div>
          <div>
            <el-button
              type="primary"
              @click="expectedInvoice"
              class="top-button"
              v-if="((available.indexOf(currUser.username) !== -1 || currUser.username == '吴少盈' || currUser.username == '戚绮琦') && projectInfo['status:project_stage'] !== '已完结' && projectInfo['status:settlement_status'] !== '已回款')"
            >
              预计开票收款时间填写
            </el-button>
            <el-button
              type="primary"
              @click="projectWrite"
              class="top-button"
              v-if="(available.indexOf(currUser.username) !== -1  && ['平台发奖服务'].indexOf(projectInfo['project:quotation_type']) === -1 && projectInfo['status:project_stage'] !== '已完结' && projectInfo['status:project_stage'] !== '暂停') && tempWhite.includes(currUser.username)"
            >
              进度填写
            </el-button>
            <el-button
              type="primary"
              @click="statusUpdateDrawer = true"
              class="top-button"
              v-if="available.indexOf(currUser.username) !== -1 && projectInfo['status:project_stage'] !== '已完结'"
            >
              修改状态
            </el-button>
          </div>

          <el-button
            type="primary"
            @click="exceptionDrawerOpen"
            class="top-button"
          >
            异常备注
          </el-button>
          <el-button
            type="primary"
            @click="orderDoneAction"
            class="top-button"
            v-if="salesManagerAvailable.indexOf(currUser.username) !== -1 && projectInfo['status:project_status'] == '已验收' && projectInfo['status:settlement_status'] == '已回款' && projectInfo['status:project_stage'] !== '已完结'"
          >
            订单完结
          </el-button>
          <el-button
            type="primary"
            @click="balanceWithdrawDrawer = true; balances()"
            class="top-button"
            v-if="financialManager.indexOf(currUser.username) !== -1 && ['平台发奖服务'].indexOf(projectInfo['project:quotation_type']) !== -1 "
          >
            发奖提现
          </el-button>
          <!--          status:project_stage-->
        </div>

      </div>
      <iframe
        class="iframe-placeholder"
        :src="dashboard"
        frameborder="0"
        width='100%'
        height="1080"
        allowtransparency
        ref="pframe"
        id="iframe2"
      ></iframe>
    </div>

    <div>
      <el-drawer
        :title="'订单编号：' + project_id"
        :visible.sync="balanceWithdrawDrawer"
        :direction="direction"
      >

        <div class="balanceWithdraw">
          <!-- <div class="balanceWithdraw-item">
              <div class="platform">微信平台：</div>
              <div class="amount">{{ balanceWithdraw_data.wechat }}</div>
              <div><el-button @click="balanceWithdraw('微信平台')">提现</el-button></div>
          </div>

          <div class="balanceWithdraw-item">
              <div class="platform">支付宝平台：</div>
              <div class="amount">{{ balanceWithdraw_data.alipay }}</div>
              <div><el-button @click="balanceWithdraw('支付宝平台')">提现</el-button></div>
          </div> -->

          <div
            class="balanceWithdraw-item"
            v-for="(item, index) in balanceWithdraw_data"
            :key="index"
          >
            <div class="platform">{{ item.platform }}：</div>
            <div class="amount">{{ item.amount }}</div>
            <div>
              <el-button @click="one_balanceWithdraw(item.platform, item.amount)">提现</el-button>
            </div>
          </div>

          <div class="balanceWithdraw-button">
            <el-button
              type="primary"
              @click="all_balanceWithdraw()"
            >全部提现</el-button>
          </div>
        </div>

      </el-drawer>
    </div>

    <div class="formDrawer">
      <el-drawer
        title="进度填报"
        :visible.sync="progressAddDrawer"
        :direction="direction"
      >

        <el-form
          ref="progressForm"
          :model="formUpdateProgress"
          label-width="80px"
          label-position="top"
          :rules="rules"
        >

          <!--          <el-form-item label="收入所属时间">-->
          <!--            <el-date-picker :disabledDate="disabledDate" type="date" v-model="formUpdateProgress.stat_time"-->
          <!--                            style="width: 100%;"></el-date-picker>-->
          <!--          </el-form-item>-->

          <el-form-item
            label="本次实际新增进度（%）"
            prop="this_progress"
          >
            <el-input
              v-model="formUpdateProgress.this_progress"
              @blur="checkTotalProgree"
            ></el-input>
          </el-form-item>

          <el-form-item label="目前累计总进度（%）">
            <el-input
              v-model="form_accu_progress"
              disabled
            ></el-input>
          </el-form-item>

          <el-form-item label="本次新增收入（含税）">
            <el-input
              v-model="form_this_income"
              disabled
            ></el-input>
          </el-form-item>

          <el-form-item label="目前累计总收入（含税）">
            <el-input
              v-model="form_accu_income"
              disabled
            ></el-input>
          </el-form-item>

          <el-form-item
            label="本次新增成本"
            prop="this_cost"
            v-if="purchase_type.indexOf(projectInfo['project:quotation_type']) !== -1"
          >
            <el-input
              v-model="formUpdateProgress.this_cost"
              required
            ></el-input>
          </el-form-item>

          <el-form-item
            label="目前累计总成本"
            v-if="purchase_type.indexOf(projectInfo['project:quotation_type']) !== -1"
          >
            <el-input
              v-model="form_accu_cost"
              disabled
            ></el-input>
          </el-form-item>

          <el-form-item label="该项目本周的工作情况">
            <el-input
              type="textarea"
              v-model="formUpdateProgress.work_desc"
              resize="none"
            ></el-input>
          </el-form-item>

          <el-form-item label="该项目本周反馈及所需协助">
            <el-input
              type="textarea"
              v-model="formUpdateProgress.work_problem"
              resize="none"
            ></el-input>
          </el-form-item>

          <el-form-item label="该项目下周计划">
            <el-input
              type="textarea"
              v-model="formUpdateProgress.work_plan"
              resize="none"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              :loading="formUpdateProgress.loading"
              type="primary"
              @click="onSubmit('progressForm')"
            >提交</el-button>
            <el-button @click="progressAddDrawer = false">取消</el-button>
          </el-form-item>

        </el-form>
      </el-drawer>
    </div>
    <div class="formDrawer">
      <makeInvoice
        :invoiceDialog.sync="invoiceDialog"
        :advanceData="advanceData"
        :projectId="projectId"
      ></makeInvoice>
    </div>
    <div class="formDrawer">
      <el-drawer
        title="修改预计交付时间"
        :visible.sync="changeEstimatedTimeDrawer"
        :direction="direction"
      >
        <el-form
          ref="changeEstimatedTimeForm"
          :model="changeEstimatedTimeData"
          label-width="80px"
          label-position="top"
          :rules="rulesChangeEstimatedTime"
        >
          <el-form-item
            label="预计交付时间"
            prop="estimated_time"
          >
            <el-date-picker
              type="date"
              v-model="changeEstimatedTimeData.estimated_time"
              :picker-options="changeEstimatedTimeData.datePickOptions"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="修改原因"
            prop="reason"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10}"
              minlength="1"
              maxlength="500"
              clearable
              show-word-limit
              placeholder="请输入修改原因"
              v-model.trim="changeEstimatedTimeData.reason"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              :loading="changeEstimatedTimeData.loading"
              type="primary"
              @click="onSubmit('changeEstimatedTimeForm')"
            >提交</el-button>
            <el-button @click="changeEstimatedTimeDrawer=false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>

    <div class="formDrawer">
      <el-drawer
        title="启动项目"
        :visible.sync="prepareStartProgressDrawer"
        :direction="direction"
      >
        <el-form
          ref="prepareStartProgressForm"
          :model="prepareStartProgressData"
          label-width="80px"
          label-position="top"
          :rules="rulesPreStartProgress"
        >
          <el-form-item
            label="订单状态"
            prop="project_status"
          >
            <el-select
              v-model="prepareStartProgressData.project_status"
              :disabled="true"
              style="width:100%"
            >
              <el-option
                v-for="(item, index) in project_status_list"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="预计交付时间"
            prop="estimated_time"
          >
            <el-date-picker
              type="date"
              v-model="prepareStartProgressData.estimated_time"
              :picker-options="prepareStartProgressData.datePickOptions"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              :loading="prepareStartProgressData.loading"
              type="primary"
              @click="onSubmit('prepareStartProgressForm')"
            >提交</el-button>
            <el-button @click="prepareStartProgressDrawer=false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-drawer>
    </div>

    <div class="formDrawer">
      <el-drawer
        title="修改状态"
        :visible.sync="statusUpdateDrawer"
        :direction="direction"
      >
        <el-form
          ref="UpdateStateForm"
          :model="formChangeState"
          label-width="80px"
          label-position="top"
          :rules="rulesChangeState"
        >
          <el-form-item
            label="订单状态"
            prop="project_status"
          >
            <el-select
              v-model="formChangeState.project_status"
              style="width:100%"
            >
              <el-option
                v-for="(item, index) in project_status_list"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="formChangeState.project_status=='已验收'"
            label="验收时间"
            prop="finish_time"
          >
            <el-date-picker
              type="date"
              v-model="formChangeState.finish_time"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              :loading="formChangeState.loading"
              type="primary"
              @click="onSubmit('UpdateStateForm')"
            >提交</el-button>
            <el-button @click="statusUpdateDrawer=false">取消</el-button>
          </el-form-item>
        </el-form>
        <div style="padding:20px 80px;font-size:14px;">
          <div style="margin-bottom: 16px;">已验收规则说明：</div>
          <div style="margin-bottom: 16px;">1. 非发奖订单，当收入=报价时（即进度100%）才可以改为"已验收"。如进度确实不能填至100%（例如有部分需求无法继续做下去），请让【客户经理】修改订单报价之后再验收。修改路径：简道云 - 订单管理 - 订单管理 - 订单数据修改 - 报价变更。</div>
          <div>2.发奖订单，当进度>=90%即可在此验收。若进度小于90%，请【项目经理】发起流程验收。流程路径：简道云
              -
              订单管理
              -
              订单管理
              -
              订单状态修改申请。</div
            >
          </div>
      </el-drawer>
    </div>

    <div class="formDrawer">
      <el-drawer
        title="异常备注"
        :visible.sync="msgUpdateDrawer"
        :direction="direction"
      >
        <el-form
          ref="msgform"
          :model="msgform"
          label-width="80px"
          label-position="top"
          :rules="msgrules"
        >
          <el-form-item
            v-if="exceptionShowBtn"
            label="订单是否异常"
            prop="order_status"
          >
            <el-select
              v-model="msgform.order_status"
              style="width:100%"
            >
              <el-option
                v-for="(item, index) in order_status_list"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="exceptionShowBtn"
            label="异常备注"
            prop="status_msg"
          >
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 10}"
              minlength="1"
              maxlength="200"
              clearable
              show-word-limit
              placeholder="请输入订单异常备注"
              v-model="msgform.status_msg"
            >
            </el-input>
          </el-form-item>
          <el-form-item v-if="exceptionShowBtn">
            <el-button
              type="primary"
              @click="onSubmit('msgform')"
            >提交</el-button>
            <el-button @click="msgUpdateDrawer=false">取消</el-button>
          </el-form-item>
        </el-form>
        <div
          v-if="!exceptionShowBtn"
          style="padding:20px;color:darkred;"
        >无法进行异常备注</div>
        <div
          v-if="exceptionNotes.length>0"
          class="exceptionList"
        >
          <div
            v-for="col in exceptionNotes"
            style="
          padding-bottom: 15px;
          border-bottom: 1px solid lightgrey;
          padding-top: 15px;
          border-bottom:solid 1px lightgrey;"
          >
            <div style="display: flex;justify-content: space-between;">
              <div style="display:flex;">{{col.project_remark}}<div style="margin-left: 10px;">{{col.stat_time}}</div>
              </div>

              <div>{{col.username}}</div>
            </div>
            <div style="display: flex;margin-top:4px;">{{col.project_comment}}</div>
          </div>
        </div>

        <!--        <el-table-->
        <!--            v-show="true"-->
        <!--            :data="exceptionNotes"-->
        <!--            style="width: 100%;padding:30px;">-->
        <!--          <el-table-column-->
        <!--              prop="stat_time"-->
        <!--              label="日期">-->
        <!--          </el-table-column>-->
        <!--          <el-table-column-->
        <!--              prop="username"-->
        <!--              label="用户">-->
        <!--          </el-table-column>-->
        <!--          <el-table-column-->
        <!--              prop="project_remark"-->
        <!--              label="状态">-->
        <!--          </el-table-column>-->
        <!--          <el-table-column-->
        <!--              prop="project_comment"-->
        <!--              label="异常备注">-->
        <!--          </el-table-column>-->
        <!--        </el-table>-->
      </el-drawer>
    </div>

  </div>

</template>

<script>

import {
  getProjectInfo,
  submitIncome,
  status_change,
  balanceWithdraw,
  balances,
  exportExcelDetail,
  remark, getUnusualList, orderDone, handleMessage, handleMessageActiveFlow, getEstimatedAdvance
} from '../api/api.js';

import {
  labour_type,
  purchase_type,
  design_type,
  prize_type,
  quotation_type,
  project_status_list,
  financialManager,
  availableInit,
  order_status_list, 
  salesManager,
  tempWhite
} from '../config/index.js'
import makeInvoice from './projectDetailComponent/makeInvoice.vue'
import VueCookies from "vue-cookies";
import {
  getLastMonthStartDate,
  getLastQuarterStartDate,
  getLastWeekStartDate,
  getLastYearStartDate, getMonthStartDate, getQuarterStartDate,
  getWeekStartDate, getYearStartDate
} from "@/utils/util";

const userid = VueCookies.get("userid")
export default {
  components: {
    makeInvoice
  },
  props: ['projectId', 'accu'],
  data () {
    var validateThisProgress = (rule, value, callback) => {
      // var numReg = /^[\-|0-9][0-9]*$/
      // var numRe = new RegExp(numReg)
      // if (value ===''){
      //     callback(new Error("请填写进度"))
      // }
      // if (!numRe.test(value)) {
      //     callback(new Error("请输入数字"));
      // }
      // if (value > 100 || value < -100) {
      //     callback(new Error("请输入-100~100之间的数字"))
      // }
      // callback();
    }
    return {
      invoiceDialog: false,
      project_id: "",
      project_ids: [],
      currUser: { "username": "" },
      financialManager: financialManager,
      available: [].concat(availableInit),//项目经理
      tempWhite: [].concat(tempWhite),
      salesManagerAvailable: [].concat(salesManager),
      dashboard: "",
      projectInfo: {},
      projectType: [],
      progressAddDrawer: false,
      direction: 'rtl',
      project_status_list: project_status_list,
      order_status_list: order_status_list,
      labour_type: labour_type,
      purchase_type: purchase_type,
      design_type: design_type,
      prize_type: prize_type,
      quotation_type: quotation_type,
      exstatus: "",
      balanceWithdrawDrawer: false,
      prepareStartProgressDrawer: false,//待启动抽屉
      changeEstimatedTimeDrawer: false, //修改预计交付时间抽屉

      statusUpdateDrawer: false,
      msgUpdateDrawer: false,
      exceptionShowBtn: true,//自己才能提交异常，别人只读

      // projectAllInfo: {},
      balanceWithdraw_data: [],


      formUpdateProgress: {
        loading: false,
        // stat_time: this.getTodayString(),
        // stat_time: new Date(),
        this_income: '',
        accu_income: '',
        this_progress: '',
        curr_progress: '',
        accu_progress: '',
        work_desc: '',
        work_problem: '',
        work_plan: '',
        // settlement_status: "",
        this_cost: '',
        accu_cost: '',
        // check_time: this.getTodayString(),
        // estimated_time: this.getTodayString()
      },
      changeEstimatedTimeData: {
        loading: false,
        estimated_time: new Date(),
        reason: '',
        datePickOptions: {
          //禁用今天往前的日期
          disabledDate (time) {
            return time.getTime() + 86400 * 1000 < Date.now();
          }
        }
      },
      prepareStartProgressData: {
        loading: false,
        project_status: '启动',
        estimated_time: new Date(),
        datePickOptions: {
          //禁用今天往前的日期
          disabledDate (time) {
            return time.getTime() + 86400 * 1000 < Date.now();
          }
        }
      },
      formChangeState: {
        loading: false,
        project_status: '',
        finish_time: ''
      },
      msgform: {
        order_status: '',//正常或异常
        status_msg: '',//200字以内订单状态描述
      },
      //异常备注列表
      advanceData: [],
      exceptionNotes: [
        // {
        //   "project_comment": "测试1",
        //   "project_id": "04205",
        //   "project_remark": "异常",
        //   "stat_time": "2022-03-21",
        //   "user_id": "123",
        //   "username": "测试"
        // },
        // {
        //   "project_comment": "测试2",
        //   "project_id": "04205",
        //   "project_remark": "异常",
        //   "stat_time": "2022-03-21",
        //   "user_id": "123",
        //   "username": "测试"
        // }
      ],
      rules: {
        // this_progress: [
        //     {required: true, validator: validateThisProgress}
        // ],
        project_status: [
          { required: true, message: "请填写订单状态" }
        ],
        this_cost: [
          { required: true, message: "请填写本次新增成本" }
        ]
      },
      rulesChangeEstimatedTime: {
        estimated_time: [
          { required: true, message: "请填写预计交付时间" }
        ],
        reason: [
          { required: true, message: "请填写修改原因" }
        ],
      },
      rulesPreStartProgress: {
        project_status: [
          { required: true, message: "请填写订单状态" }
        ],
        estimated_time: [
          { required: true, message: "请填写预计交付时间" }
        ]
      },
      rulesChangeState: {
        project_status: [
          { required: true, message: "请填写订单状态" }
        ],
        finish_time: [
          { required: true, message: "请填写验收时间" }
        ]
      },
      msgrules: {
        order_status: [
          { required: true, message: "请选择订单是否异常" }
        ],
        status_msg: [
          { required: true, message: "请填写异常描述" }
        ]
      }
    }
  },

  created () {
    // console.log('this.accu', this.accu)
    let projects = this.projectId.split(',')
    // console.log('projects', projects)
    if (projects.length == 1) {
      // console.log('length1')
      this.project_id = this.projectId
      this.dashboard = "http://139.196.75.8:81/public/dashboard/d624be47-ca71-42a8-887d-e45b523d822d?%25E8%25AE%25A2%25E5%258D%2595%25E7%25BC%2596%25E5%258F%25B7=" + this.project_id;
      //单个项目可编辑，多个项目查看只读
      this.getProjectInfoAction()
    } else if (projects.length > 1) {
      this.project_id = projects[0]
      this.project_ids = projects
      let url = "http://139.196.75.8:81/public/dashboard/d624be47-ca71-42a8-887d-e45b523d822d?"
      let isFirst = true
      for (const projectid of projects) {
        if (isFirst) {
          url += '%25E8%25AE%25A2%25E5%258D%2595%25E7%25BC%2596%25E5%258F%25B7=' + projectid
          isFirst = false
        } else {
          url += '&%25E8%25AE%25A2%25E5%258D%2595%25E7%25BC%2596%25E5%258F%25B7=' + projectid
        }
      }
      this.dashboard = url
    }


    //   this.project_id = this.$store.state.projectId;
    this.currUser = {
      username: this.$cookies.get("username")
    };

    // console.log('this.currUser', this.currUser)


    // this.balances()
  },

  computed: {
    form_accu_progress () {
      if ((isNaN(parseFloat(this.formUpdateProgress.this_progress)) ? 0 : parseFloat(this.formUpdateProgress.this_progress)) === 0) {
        // return Math.round((this.projectInfo['amount:income'] / this.projectInfo['amount:quotation']) * 100, 2);
        return parseFloat((this.projectInfo['amount:income'] / this.projectInfo['amount:quotation']) * 100).toFixed(4);
      } else {
        return ((isNaN(parseFloat(this.formUpdateProgress.curr_progress)) ? 0 : parseFloat(this.formUpdateProgress.curr_progress)) + (isNaN(parseFloat(this.formUpdateProgress.this_progress)) ? 0 : parseFloat(this.formUpdateProgress.this_progress))).toFixed(4);
      }
    },

    form_accu_income () {
      // return Math.round(this.form_accu_progress / 100 * this.projectInfo['amount:quotation'], 2);
      return parseFloat(this.form_accu_progress / 100 * this.projectInfo['amount:quotation']).toFixed(2)
    },

    form_this_income () {
      // return Math.round(this.form_accu_income - this.projectInfo['amount:income'], 2);
      return parseFloat(this.projectInfo['amount:quotation'] / 100 * this.formUpdateProgress.this_progress).toFixed(2);
    },

    form_accu_cost () {
      // return Math.round(this.formUpdateProgress.accu_cost + (isNaN(parseFloat(this.formUpdateProgress.this_cost))?0:parseFloat(this.formUpdateProgress.this_cost)), 2)
      return parseFloat(this.formUpdateProgress.accu_cost + (isNaN(parseFloat(this.formUpdateProgress.this_cost)) ? 0 : parseFloat(this.formUpdateProgress.this_cost))).toFixed(2)
    }
  },

  mounted () {
    // console.log('this.$refs.pframe', document.getElementById('iframe2'))
    // console.log()
    // let that = this
    // setInterval(() => {
    //   let contentWindow = document.getElementById('iframe2').contentWindow;
    //   // console.log('contentWindow', contentWindow.location)
    //   // console.log('document.getElementById(\'iframe2\')', document.getElementById('iframe2'))
    //   // console.log('doucment',)
    //   console.log('that.dashboard', that.dashboard)
    // }, 10000)
    window.vm2 = this

  },

  updated () {

  },

  methods: {

    async exceptionDrawerOpen () {
      this.msgUpdateDrawer = true
      // this.exceptionShowBtn = this.available.indexOf(this.currUser.username) !== -1
      try {
        let res = await getUnusualList({ project_id: this.project_id })
        // console.log('getUnusualList/res',res.data)
        this.exceptionNotes = res.data.respData
      } catch (error) {
        this.$message.warning(error)
      }
    },

    projectWrite () {
      // console.log('projectWrite')
      this.progressAddDrawer = true
    },
    async expectedInvoice () {
      const res = await getEstimatedAdvance({
        project_id: this.project_id
      })
      this.advanceData = res.data.respData
      this.invoiceDialog = true
    },
    /**
     * 获取项目信息
     * @returns {Promise<void>}
     */
    async getProjectInfoAction () {
      return new Promise(async (resolve) => {
        // console.log('getProjectInfoAction',this.project_id)
        try {
          let res = await getProjectInfo({ project_id: this.project_id })
          if (res.data) {
            this.projectInfo = res.data;
            // console.log('this.projectInfo', this.projectInfo)
            this.formUpdateProgress.accu_income = this.projectInfo['amount:income'];
            this.formUpdateProgress.accu_cost = this.projectInfo['amount:cost'];
            // this.formUpdateProgress.project_status = this.projectInfo['status:project_status'];
            // this.formChangeState.project_status = this.projectInfo['status:project_status'];
            this.exstatus = this.projectInfo['status:project_status'];
            // this.formUpdateProgress.settlement_status = this.projectInfo['status:settlement_status'];
            this.formUpdateProgress.curr_progress = (this.projectInfo['amount:income'] / this.projectInfo['amount:quotation']) * 100;
            this.available = this.available.concat([this.projectInfo['member:project_manager'], this.projectInfo['member:account_manager']])
            this.salesManagerAvailable = this.salesManagerAvailable.concat([this.projectInfo['member:account_manager']])
            resolve(1)
          } else {
            this.$message.warning("获取项目信息为空")
            resolve(0)
          }

        } catch (e) {
          // console.error("获取项目信息出错了！",e)
          this.$message.error("获取项目信息出错了")
          resolve(0)
        }
      })

    },

    async orderDoneAction () {
      let quotation = this.projectInfo['amount:quotation']
      let income = this.projectInfo['amount:income']
      let collection = this.projectInfo['amount:collection']
      // console.log('quotation',quotation,'income',income,'collection',collection)
      if (Math.abs((quotation - income)) > 0.5 && Math.abs((income - collection)) > 0.5) {
        this.$message.warning(`报价、收入和回款不一致，如有问题请联系管理员戚绮琦和吴少盈`)
        return
      }
      if (Math.abs((quotation - income)) > 0.5) {
        this.$message.warning(`报价和收入不一致，如有问题请联系管理员戚绮琦和吴少盈`)
        return
      }
      if (Math.abs((income - collection)) > 0.5) {
        this.$message.warning(`收入和回款不一致，如有问题请联系管理员戚绮琦和吴少盈`)
        return
      }



      let isComfirm = await this.openDoneConfirm()
      if (isComfirm) {
        // console.log('TODO:订单完结请求接口')
        try {
          let res = await orderDone({ project_id: this.project_id })
          if (res) {
            this.$message.success(res.data.respMsg)
            this.refreshData()
          } else {
            this.$message.error(res.data.respMsg)
          }
        } catch (error) {
          this.$message.warning(error)
        }
      } else {
        // console.log('取消完结订单操作')
      }


    },

    async openDoneConfirm () {
      return new Promise(resolve => {
        this.$confirm('确定将订单状态设置为已完结?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          resolve(true)
        }).catch(() => {
          resolve(false)
        });
      })
    },

    exportExcel () {
      // console.log(this.project_id)
      this.export()

    },
    async export () {
      let param = {
        userid: userid,
        op: "export"
      }
      let loadingInstance = this.$loading.service({ fullscreen: true, text: '请等待导出' });
      try {
        let { data } = await exportExcelDetail(this.project_id, param)
        loadingInstance.close();
        const blob = new Blob([data])
        var date = new Date()
        let Y = date.getFullYear().toString()
        let M = (date.getMonth() + 1).toString().padStart(2, "0")
        let D = date.getDate().toString().padStart(2, "0")
        let H = date.getHours().toString().padStart(2, "0")
        let m = date.getMinutes().toString().padStart(2, "0")
        let s = date.getSeconds().toString().padStart(2, "0")
        const fileName = this.$store.state.projectInfo.projectName + '-详情' + '-' + Y + M + D + H + m + s + ".xlsx"
        const link = document.createElement('a')
        link.download = fileName // a标签添加属性
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        document.body.appendChild(link)
        link.click() // 执行下载
        URL.revokeObjectURL(link.href) // 释放url
        document.body.removeChild(link) // 释
      } catch (err) {
        loadingInstance.close();

        this.$message.warning(`导出失败,请尝试使用其他浏览器,错误信息(${err})`)

        // var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
        // if(issafariBrowser){
        //   this.$message.warning( `导出失败,请尝试使用其他浏览器,错误信息(${err})` )
        // }else{
        //   this.$message.warning("暂不支持在Safari浏览器中导出，请使用其他浏览器")
        // }

      }

    },
    iframeLoad (e) {
      // console.log('iframeLoad', e)
    },
    checkTotalProgree () {
      let curr_progress_difference = this.projectInfo['amount:quotation'] - this.form_accu_income
      // console.log('checkTotalProgree',curr_progress_difference)
      if (curr_progress_difference < 0) {
        this.showAdjustTotalProgreeModal()
      }
    },

    showAdjustTotalProgreeModal () {
      this.$confirm('填写当前数值后，该项目进度将会超过100%，是否将项目进度调整至100%', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.formUpdateProgress.this_progress = 0
        this.formUpdateProgress.this_progress = 100 - this.form_accu_progress
        let curr_progress_difference = this.projectInfo['amount:quotation'] - this.form_accu_income
        if (curr_progress_difference === 0) {
          this.$message({
            type: 'success',
            message: '已将项目进度调整至100%!'
          });
        }
      }).catch(() => {
        //设置的当前进度值为空
        this.formUpdateProgress.this_progress = ''
        this.$message({
          type: 'info',
          message: '已恢复为原进度'
        });
      });
    },


    balances () {
      var data = {
        project_id: this.project_id
      }
      balances(data)
        .then((response) => {
          this.balanceWithdraw_data = response.data.res
          this.refreshData()
        })
        .catch((error) => {
          // console.log(error)
        })
    },

    disabledDate (time) {
      var today = new Date()
      if (today.getDay() === 0) {
        var date = new Date()
        var currentMonth = date.getMonth();
        var lastMonth = --currentMonth;
        var lastMonthFirstday = new Date(date.getFullYear(), lastMonth, 1)
        var currentMonth = date.getMonth();
        var nextMonth = ++currentMonth;
        var nextMonthFirstday = new Date(date.getFullYear(), nextMonth, 1)
        return time.getTime() <= lastMonthFirstday || time.getTime() >= nextMonthFirstday
      } else {
        var date = new Date()
        date.setDate(0);
        var endDate = new Date();
        var currentMonth = endDate.getMonth();
        var nextMonth = ++currentMonth;
        var nextMonthFirstday = new Date(endDate.getFullYear(), nextMonth, 1)
        return time.getTime() <= date || time.getTime() >= nextMonthFirstday
      }
    },


    refreshData () {
      this.dashboard = "http://139.196.75.8:81/public/dashboard/d624be47-ca71-42a8-887d-e45b523d822d?%25E8%25AE%25A2%25E5%258D%2595%25E7%25BC%2596%25E5%258F%25B7=" + this.project_id;
      this.$refs.pframe.src = this.dashboard;
      this.getProjectInfoAction()
    },

    getTodayString () {
      const d = new Date();
      return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
    },

    dateformat (date) {
      var month = (date.getMonth() + 1)
      var day = date.getDate()
      if ((date.getMonth() + 1) < 10) {
        month = '0' + (date.getMonth() + 1)
      }
      if (date.getDate() < 10) {
        day = '0' + date.getDate()
      }

      return date.getFullYear() + '-' + month + '-' + day;
      // return date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate();
    },

    one_balanceWithdraw (platform, amount) {
      var data_list = [
        {
          "platform": platform,
          "amount": amount,
          "project_id": this.project_id,
          "project_name": this.projectInfo['project:project_name'],
          "client_name": this.projectInfo['client:client_name']
        }
      ]
      this.balanceWithdraw(data_list)
    },

    all_balanceWithdraw () {
      var data_list = []
      for (var i in this.balanceWithdraw_data) {
        var data = {
          "platform": this.balanceWithdraw_data[i].platform,
          "amount": this.balanceWithdraw_data[i].amount,
          "project_id": this.project_id,
          "project_name": this.projectInfo['project:project_name'],
          "client_name": this.projectInfo['client:client_name']
        }
        data_list.push(data)
      }
      this.balanceWithdraw(data_list)
    },

    balanceWithdraw (data_list) {
      var data = {
        withdraw_list: data_list
      }
      balanceWithdraw(data)
        .then((response) => {
          this.$message.success({
            message: platform + '提现成功',
            type: 'success'
          })
          this.balances()
        })
        .catch((error) => {
          // console.log(error)
          this.$message.error(platform + "提现失败")
          this.balances()
        })
    },

    async onSubmit (formName) {
      var that = this
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (formName === 'changeEstimatedTimeForm') {
            let loadingInstance = this.$loading.service({ fullscreen: true, text: '处理中...' });
            this.changeEstimatedTimeData.loading = true
            let postData = {
              type: "part",
              message_type: 10,
              username: that.$cookies.get("username"),
              business_id: that.projectInfo['project:project_id'],
              business: 'project',
              new_time: this.dateformat(this.changeEstimatedTimeData.estimated_time),
              reason: this.changeEstimatedTimeData.reason
            }
            // console.log('handleMessageRquest',postData)
            let res = await handleMessageActiveFlow(postData)
            if (res.respCode && res.respCode == '000000') {
              // console.log('handleMessageRquest',res)
              this.$message.success(res.respMsg)
              this.$emit("updateList")
              this.changeEstimatedTimeDrawer = false
              this.changeEstimatedTimeData.estimated_time = ''
              this.changeEstimatedTimeData.reason = ''
            } else {
              this.$message.error(res.respMsg)
            }
            this.changeEstimatedTimeData.loading = false
            loadingInstance.close()

          }
          else if (formName === 'progressForm') {//进度填报

            // console.log('progressForm进度填报/this.projectInfo', that.projectInfo)
            // if(this.form_this_income == 0){
            //   this.$message.error("订单未确认报价，不能填写进度")
            //   return;
            // }
            if (this.projectInfo['time:first_quotation_time'] == null) {
              // console.log("this.projectInfo/this.projectInfo['time:first_quotation_time']",this.projectInfo,this.projectInfo['time:first_quotation_time'])
              this.$message.error("订单未确认报价，不能填写进度")
              return;
            }
            if (this.projectInfo.project_status == "已验收") {
              //that.form_accu_income//目前累计收入
              //实际收入
              let curr_progress_difference = that.projectInfo['amount:quotation'] - that.form_accu_income
              // console.log('onSubmit.progressForm:curr_progress_difference', curr_progress_difference)
              if (curr_progress_difference > 0.5) {//实际需收金额-已收金额 差距>0.5元
                this.$message.error("进度未达到100%，设置订单状态为已验收失败")
                return;
              } else if (curr_progress_difference < -0.5) {
                this.$message.error("进度异常，设置订单状态为已验收失败")
                return;
              }
            }

            let loadingInstance = this.$loading.service({ fullscreen: true, text: '处理中...' });
            this.formUpdateProgress.loading = true
            var data = {
              username: that.$cookies.get("username"),
              project_manager_name: that.projectInfo['member:project_manager'],
              quotation_type: that.projectInfo['project:quotation_type'],
              project_id_name: that.projectInfo['project:project_name'] + '-' + that.projectInfo['project:project_id'],
              project_id: that.projectInfo['project:project_id'],
              project_name: that.projectInfo['project:project_name'],
              business_type: that.projectInfo['project:business_type'],
              applicant_name: that.projectInfo['member:project_director'],
              client_name: that.projectInfo['client:client_name'],
              contract: that.projectInfo['contract'],
              tax_rate: that.projectInfo['project:tax_rate'],
              final_quotation: that.projectInfo['amount:quotation'],
              final_quotation_no_tax: that.projectInfo['amount:quotation'] / (1 + parseFloat(that.projectInfo['project:tax_rate'])),
              primary_dept_no: that.projectInfo['responsible_p_dept_no'],
              primary_dept_text: that.projectInfo['dept:responsible_p_dept'],
              secondary_dept_no: that.projectInfo['responsible_s_dept_no'],
              secondary_dept_text: that.projectInfo['dept:responsible_s_dept'],
              account_manager_id: that.projectInfo['account_manager_id'],
              account_manager_text: that.projectInfo['member:account_manager'],
              project_manager_id: that.projectInfo['project_manager_id'],
              project_manager_text: that.projectInfo['member:project_manager'],
              stat_time: that.dateformat(new Date()),//取当天时间
              income: that.form_this_income,
              income_no_tax: that.form_this_income / (1 + parseFloat(that.projectInfo['project:tax_rate'])),
              accu_income: that.form_accu_income,
              accu_income_no_tax: that.form_accu_income / (1 + parseFloat(that.projectInfo['project:tax_rate'])),
              work_brief: that.formUpdateProgress.work_desc,
              work_problem: that.formUpdateProgress.work_problem,
              work_plan: that.formUpdateProgress.work_plan,
              // estimated_delivery_time: that.dateformat(that.formUpdateProgress.estimated_time),
              // project_status: that.formUpdateProgress.project_status, // 已验收
              // settlement_status: that.formUpdateProgress.settlement_status, //已回款
              accu_progress: that.form_accu_progress,
              cost: parseFloat(that.formUpdateProgress.this_cost),
              accu_cost: that.form_accu_cost,
              client_region: that.projectInfo['region:client_region']
            }
            // console.log('data',data)
            // return
            try {
              let res = await submitIncome(data)
              // console.log('submitIncome/res',res)
              if (res.data.msg === '成功') {
                that.$message.success({
                  message: res.data.msg,
                  type: 'success'
                })
                that.formUpdateProgress.this_income = '',
                  that.formUpdateProgress.accu_income = '',
                  that.formUpdateProgress.this_progress = '',
                  that.formUpdateProgress.curr_progress = '',
                  that.formUpdateProgress.accu_progress = '',
                  that.formUpdateProgress.work_desc = '',
                  that.formUpdateProgress.work_problem = '',
                  that.formUpdateProgress.work_plan = '',
                  // that.formUpdateProgress.project_status = '',
                  // that.formUpdateProgress.settlement_status = "",
                  that.formUpdateProgress.this_cost = '',
                  that.progressAddDrawer = false
                //2、更新数据成功，获取新的订单数据
                let res2 = await getProjectInfo({ project_id: that.project_id })
                // console.log('getProjectInfo/res2',res2)
                if (res2.data) {
                  this.projectInfo = res.data;
                  this.formUpdateProgress.accu_income = this.projectInfo['amount:income'];
                  this.formUpdateProgress.accu_cost = this.projectInfo['amount:cost'];
                  // this.formUpdateProgress.project_status = this.projectInfo['status:project_status'];
                  // this.formChangeState.project_status = this.projectInfo['status:project_status'];
                  this.exstatus = this.projectInfo['status:project_status'];
                  // this.formUpdateProgress.settlement_status = this.projectInfo['status:settlement_status'];
                  this.formUpdateProgress.curr_progress = (this.projectInfo['amount:income'] / this.projectInfo['amount:quotation']) * 100;
                  this.available = this.available.concat([this.projectInfo['member:project_manager'], this.projectInfo['member:account_manager']])
                  this.refreshData()
                } else {
                  that.$message.error("getProjectInfo失败")
                }

              } else {
                that.$message.error(res.data.msg)
              }
              this.formUpdateProgress.loading = false
              loadingInstance.close()

            } catch (error) {
              // console.log('submitIncome失败')
              this.formUpdateProgress.loading = false
              loadingInstance.close()
              that.$message.error(error)
            }


            // this.balances()

          }
          else if (formName === 'UpdateStateForm') {
            //修改状态按钮提交


            //如果项目状态改为已验收时，需要判断进度是否百分百
            // console.log('that.formChangeState.project_status', that.formChangeState.project_status)
            // console.log('this.projectInfo', this.projectInfo)
            // let curr_progress = (this.projectInfo['amount:income'] / this.projectInfo['amount:quotation']) * 100;

            //如果计价类型是 '奖品发放（代发奖品）', '平台发奖服务'，不校验是否已验收
            let isAwardType = ['平台发奖服务'].indexOf(this.projectInfo['project:quotation_type']) !== -1
            // console.log("计价类型是否平台发奖服务",isAwardType)



            if (isAwardType) {
              if (that.formChangeState.project_status === "已验收") {
                let current_progress = Number(that.form_accu_progress)
                // console.log("平台发奖服务，校验进度90%以上",current_progress)
                if (current_progress < 90) {
                  // console.log('平台发奖服务，进度90%以下，不通过')
                  this.$message.error("平台发奖服务进度未达到90%以上，设置订单状态为已验收失败")
                  return;
                } else {
                  // console.log('平台发奖服务，进度90%及以上，通过')
                }
              }
            } else {
              if (that.formChangeState.project_status === "已验收") {
                if (this.projectInfo['amount:quotation'] == 0 || this.projectInfo['amount:income'] == 0) {
                  this.$message.error("金额为0，设置订单状态为已验收失败")
                  return;
                }
                let curr_progress_difference = this.projectInfo['amount:quotation'] - this.projectInfo['amount:income']
                // console.log('onSubmit:curr_progress_difference', curr_progress_difference)
                if (curr_progress_difference > 0.5) {//实际需收金额-已收金额 差距>0.5元
                  this.$message.error("进度未达到100%，设置订单状态为已验收失败")
                  return;
                } else if (curr_progress_difference < -0.5) {
                  this.$message.error("进度异常，设置订单状态为已验收失败")
                  return;
                }
              }
            }


            let loadingInstance = this.$loading.service({ fullscreen: true, text: '处理中...' });
            this.formChangeState.loading = true
            var data = {
              username: this.$cookies.get("username"),
              project_id: that.projectInfo['project:project_id'],
              project_status: that.formChangeState.project_status
            }

            if (that.formChangeState.project_status == '已验收') {
              data['finish_time'] = this.dateformat(that.formChangeState.finish_time)
            }
            // console.log('修改状态请求数据',data)

            status_change(data)
              .then(() => {
                this.statusUpdateDrawer = false

                getProjectInfo({
                  project_id: that.project_id
                }).then((res) => {
                  // console.log(res.data)
                  this.projectInfo = res.data;
                  this.formUpdateProgress.accu_income = this.projectInfo['amount:income'];
                  this.formUpdateProgress.accu_cost = this.projectInfo['amount:cost'];
                  // this.formUpdateProgress.project_status = this.projectInfo['status:project_status'];
                  // this.formChangeState.project_status = this.projectInfo['status:project_status'];
                  this.exstatus = this.projectInfo['status:project_status'];
                  // this.formUpdateProgress.settlement_status = this.projectInfo['status:settlement_status'];
                  this.formUpdateProgress.curr_progress = (this.projectInfo['amount:income'] / this.projectInfo['amount:quotation']) * 100;
                  this.available = this.available.concat([this.projectInfo['member:project_manager'], this.projectInfo['member:account_manager']])

                  this.formChangeState.project_status = ''
                  this.formChangeState.finish_time = ''

                  this.formChangeState.loading = false
                  loadingInstance.close()
                  this.$message.success("修改状态成功")


                }).catch((error) => {
                  this.formChangeState.loading = false
                  loadingInstance.close()
                  // console.log(error)
                  this.$message.warning(error)
                })

                this.balances()


              })
              .catch((error) => {
                this.formChangeState.loading = false
                loadingInstance.close()
                // console.log(error)
              })
          }
          else if (formName === 'msgform') {

            var data = {
              user_name: this.$cookies.get("username"),
              user_id: this.$cookies.get("userid"),
              project_id: that.projectInfo['project:project_id'],
              project_remark: that.msgform.order_status,//订单是否异常
              project_comment: that.msgform.status_msg//异常描述
            }
            // console.log('请求接口表单提交',data)

            remark(data)
              .then((res) => {
                // console.log('abnormal_change success:', res.data)
                //清空表单
                this.msgform.order_status = ""
                this.msgform.status_msg = ""
                this.msgUpdateDrawer = false
                this.$message.success(res.data.respMsg)
                // console.log('remark成功后刷新页面')
                this.refreshData()
                this.$nextTick(() => {
                  this.$refs['msgform'].resetFields();
                })
              })
              .catch((error) => {
                this.$message.warning(error)
                // console.log("abnormal_change error:", error)
              })
          }
          else if (formName == 'prepareStartProgressForm') {//待启动
            let loadingInstance = this.$loading.service({ fullscreen: true, text: '处理中...' });
            this.prepareStartProgressData.loading = true
            var postData = {
              username: this.$cookies.get("username"),
              project_id: this.projectInfo['project:project_id'],
              project_status: this.prepareStartProgressData.project_status,
              estimated_delivery_time: this.dateformat(this.prepareStartProgressData.estimated_time)
            }
            // console.log('待启动改为启动',postData)
            await status_change(postData)
            let action = await this.getProjectInfoAction()
            if (action) {
              this.prepareStartProgressDrawer = false
              this.$message.success("项目启动成功")
              this.balances()
            }
            this.prepareStartProgressData.loading = false
            loadingInstance.close()
          }
        }
      })
    }
  }

}
</script>

<style scoped>
.exceptionList {
  width: 70%;
  margin: auto;
  border-top: solid 1px black;
  font-size: 14px;
  padding: 20px 0;
}
.detail {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.project-meta {
  width: 20%;
  margin-top: 20px;
}

.project-type h3 {
  display: flex;
  justify-content: flex-start;
}

.project-summary h3 {
  display: flex;
  justify-content: flex-start;
}

.project-action {
  width: 70%;
  margin-top: 20px;
}

.project-action h3 {
  display: flex;
  justify-content: flex-start;
}

.action {
  display: flex;
  justify-content: flex-end;
}

.data {
  margin-top: 10px;
}

.formDrawer >>> .el-drawer {
  overflow: scroll;
}

.formDrawer .el-form {
  width: 70%;
  margin: auto;
}

.formDrawer .el-form-item {
  text-align: left;
}

.balanceWithdraw {
  width: 100%;
  text-align: left;
}

.balanceWithdraw-item {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.platform {
  width: 30%;
}

.amount {
  width: 30%;
}

.balanceWithdraw-button {
  width: 100%;
  margin-top: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.iframe-placeholder {
  margin-top: 10px;
  background: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 100% 100%"><text fill="%238B8B8B" x="50%" y="50%" font-family="\'Lucida Grande\', sans-serif" font-size="24" text-anchor="middle">页面加载中</text></svg>')
    0px 0px no-repeat;
}

.top-button {
  margin-top: 12px;
  margin-right: 16px;
  margin-left: 0px;
}
</style>
